import { Component, ElementRef, Input } from '@angular/core';
import { Line, LineOptions } from '@antv/g2plot';
import { UserApiService } from 'src/app/services/api/user-api.service';

@Component({
  selector: 'app-user-affiliate-order-line-card',
  templateUrl: './user-affiliate-order-line-card.component.html',
  styleUrls: ['./user-affiliate-order-line-card.component.scss'],
})
export class UserAffiliateOrderLineCardComponent {
  @Input() height = '327px';
  constructor(private api: UserApiService, private el: ElementRef) {}

  ngOnInit(): void {
    this.findUserAffiliateUserOrder14days();
  }

  data: any[] = [];
  plot: Line | null = null;
  loading = false;
  async findUserAffiliateUserOrder14days() {
    try {
      this.loading = true;
      const r = await this.api.findUserAffiliateUserOrder14days();
      this.data = r.data;
      if (this.data.length > 0) {
        this.render();
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  render() {
    if (!this.data) {
      return;
    }
    const cfg: LineOptions = {
      data: this.data,
      xField: 'date',
      yField: 'order_count',
      seriesField: 'platform',
      smooth: true,
      autoFit: true,
      legend: {
        // position: 'top',
        flipPage: false,
        title: {
          text: '各平台的订单数(冻结和结算的订单)',
          style: {
            fontSize: 18,
            fontWeight: 'bold',
          },
        },
      },
      xAxis: {
        title: {
          text: '日期',
        },
        // type: 'time',
      },
      tooltip: {
        customItems: (items: any[]) => {
          let total = 0;
          let price = 0;
          for (const item of items) {
            if (item.name === '总计') {
              continue;
            }
            total += item.data.order_count;
            price += item.data.commission;
            item.value =
              item.value + '(￥' + item.data.commission.toFixed(2) + ')';
          }

          items.sort((a, b) => {
            return b.data.order_count - a.data.order_count;
          });
          items.push({
            name: '总计',
            value: total.toString() + '(￥' + price.toFixed(2) + ')',
          });
          return items;
        },
      },
      animation: {
        appear: {
          animation: 'path-in',
          duration: 1000,
        },
      },
    };
    if (!this.plot) {
      this.plot = new Line(
        this.el.nativeElement.querySelector('#container'),
        cfg
      );
    } else {
      this.plot.update(cfg);
    }
    this.plot.render();
  }
}
